import React, { useState } from "react";

import { Autocomplete, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField, Button, LinearProgress } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';

import config from '../../../hoa-config';

import '../../hoa-styles.scss';
import '../../municipalities/hoa-municipality-styles.scss';
import { CheckBox } from "@mui/icons-material";
import dashboardServices from "../../../services/hoa-dashboard-api-service";
interface HoaBasicFormProps {
    getMunicipalities: any,
    selectedMunicipality: any,
    setSelectedMunicipality: any,
    height: number,
    proceedToAdd: any;
    onCancelYesClick: any;
}


export default function HoaSelectMunicipalityForm(props: HoaBasicFormProps) {

    const stateList: any = {
        name: '',
        id: '',
    }
    const { getMunicipalities, setSelectedMunicipality, selectedMunicipality, proceedToAdd, onCancelYesClick } = props;
    const [state, setState] = useState(stateList);
    const [municipalityList, setMunicipalityList] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (value: any, key: string) => {
        let tempState: any = { ...state };
        tempState[key] = value;
        setState(tempState);
    }

    const handleSearch = async () => {
        setLoading(true);
        let result;
        
        if (state.id) {
            result = await dashboardServices.getMunicipalityById(state.id);
            if (result) {
                setMunicipalityList([result.data]);
            } else {
                setMunicipalityList([]);
            }
        } else {
            result = await getMunicipalities(state);
            setMunicipalityList(result?.municipalities || []);
        }
    
        setLoading(false);
    }

    return (
        <div style={{ width: "100%", height: props.height, borderRadius: "4px", fontSize: '20px' }} className="add-municipality-form-container">
            <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", padding: "24px", boxSizing: "border-box" }}>
                <div className="sub-title-text">Select Municipality</div>
                <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between", alignItems:'center', padding:"0px 5%" }}>
                    <TextField style={{ width: "30%" }} variant="standard" label="Municipality Name" value={state.name}
                        onChange={(e) => { handleChange(e.target.value, "name") }} InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }} />
                    <TextField style={{ width: "30%" }} variant="standard" label="Municipality ID" value={state.id}
                        onChange={(e) => { handleChange(e.target.value, "id") }} InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }} />
                    <div style={{display:"flex"}}>
                        <Button onClick={onCancelYesClick} variant="outlined" color="primary" style={{ height: "40px", padding: "5px 25px", marginRight:"10px" }}>
                            Cancel
                        </Button>
                        <Button disabled={!state.name && !state.id} onClick={handleSearch} variant="contained" color="primary" style={{ height: "40px", padding: "5px 25px" }}>
                            Search
                        </Button>
                    </div>
                </div>
                {
                    loading ? <LinearProgress style={{margin:"5px 0px"}}/> : ''
                }

                {
                    municipalityList.length > 0 &&
                    <div style={{ display:"flex", alignItems:"center", flexDirection: 'column', marginTop:"10px", width: "100%", maxHeight: window.innerHeight - 300}}>
                    <div style={{minWidth:"70%", maxWidth:"95%", maxHeight: window.innerHeight - 350}}>
                        <TableContainer style={{border: "1px solid #E8E8E8", margin:"0px", height:"100%"}}>
                            <Table style={{margin:"0px"}} aria-label="simple table" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{backgroundColor:"#F7F7F7"}}>Name</TableCell>
                                        <TableCell style={{backgroundColor:"#F7F7F7"}} align="left">Market</TableCell>
                                        <TableCell style={{backgroundColor:"#F7F7F7"}} align="left">State</TableCell>
                                        <TableCell style={{backgroundColor:"#F7F7F7"}} align="left">Zip</TableCell>
                                        <TableCell style={{backgroundColor:"#F7F7F7", width:"30px"}}> </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{overflowY: "auto", }}>
                                    {municipalityList.map((municipality : any) => (
                                        <TableRow
                                            key={municipality.objectId}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            onClick={()=>{setSelectedMunicipality(municipality)}}
                                        >
                                            <TableCell component="th" scope="row" style={{wordBreak:"break-word"}}>
                                                {municipality.name}
                                            </TableCell>
                                            <TableCell align="left">{municipality.market}</TableCell>
                                            <TableCell align="left">{municipality.state}</TableCell>
                                            <TableCell align="left">{municipality.zip}</TableCell>
                                            <TableCell align="left">{selectedMunicipality && selectedMunicipality.objectId === municipality.objectId ? <CheckCircle color="primary"/> : ''}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        </div>
                        <Button disabled = {!selectedMunicipality.market} onClick={proceedToAdd} variant="contained" color="primary" style={{ height: "40px", padding: "10px 45px" , width:"200px", margin:"12px 0px"}}>
                            Next
                        </Button>
                    </div>
                }
            </div>
        </div>
    )
}